export default "__VITE_ASSET__6322197e__"